import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  BezoekschipOrganisation, Carrier,
  FindCarriers,
  FindOrganisations,
  LinerService
} from "@portbase/bezoekschip-service-typescriptmodels";
import {PortvisitUtils} from "../portvisit-utils";
import {sendQuery} from "../../common/utils";
import {map} from "rxjs/operators";

@Component({
    selector: 'app-edit-liner-service',
    templateUrl: './edit-liner-service.component.html',
    styleUrls: ['./edit-liner-service.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditLinerServiceComponent {
  formatter = PortvisitUtils.agentFormatter;
  carrierFormatter = (carrier: Carrier) => carrier.name + ' (' + carrier.customsId + ')';

  @Input() linerService: LinerService;

  searchCarriers = term => sendQuery('com.portbase.bezoekschip.common.api.visit.FindCarriers',
    <FindCarriers>{term: term, withCustomsId: true});

  searchOrganisation = term => sendQuery('com.portbase.bezoekschip.common.api.authorisation.FindOrganisations',
    <FindOrganisations>{term: term});

  searchPortsOfCall = sendQuery('com.portbase.bezoekschip.common.api.visit.GetPcsPorts', {})
    .pipe(map(ports => ports.map(p => p.port.locationUnCode)));

  setStevedoreOrganisationShortName = (stevedore: BezoekschipOrganisation) => {
    if (!stevedore) {
      this.linerService.stevedoreOrganisationShortName = "";
    } else {
      this.linerService.stevedoreOrganisationShortName = stevedore.shortName;
    }
  };

  setCarrierOrganisationsEoriNumbers = (carriers: any[]) => {
    if (!carriers) {
      this.linerService["carrierOrganisationsEoriNumbers"] = [];
    } else {
      this.linerService["carrierOrganisationsEoriNumbers"] = carriers
        .map(carrier => typeof carrier === "string" ? carrier : carrier.customsId)
        .filter(eori => eori.trim().length > 0);
    }
  };

  setCarrierOrganisationsShortNames = (carriers: any[]) => {
    if (!carriers) {
      this.linerService.carrierOrganisationsShortNames = [];
    } else {
      this.linerService.carrierOrganisationsShortNames = carriers
        .map(carrier => carrier ? (typeof carrier === "string" ? carrier : carrier.shortName) : "")
        .filter(carrier => carrier && typeof carrier === "string" && carrier.trim().length > 0);
    }
  };

  setPortUnloCode = (portUnloCode: string) => {
    console.log(portUnloCode);
    if (!portUnloCode) {
      this.linerService.harbourDuesPort = "";
    } else {
      this.linerService.harbourDuesPort = portUnloCode;
    }
  }
}
